import React from "react";

import { useGetApplicationQuery } from "EmployeeApplication/api";
import { WholeLifePage } from "EmployeeCoverage/Components/WholeLife";
import { Link } from "react-router-dom";
import BasicLoading from "ZeroRuby/BasicLoading";

import BodyText from "Cobalt/BodyText";
import { CardSection } from "Cobalt/Card";
import { RoutedBackButton } from "Common/forms/buttons";

import MissingZipCode from "./components/MissingZipCode";
import Page from "./Page";

const NoCoverageOffered = () => (
  <CardSection>
    <BodyText size="large" agent>
      Your company does not offer whole life insurance at this time.
    </BodyText>
  </CardSection>
);

const useData = () => {
  const { isLoading: isLoadingApplication, data: { employeePolicy: { employeeForm: { zipCode } = {} } = {}, availablePlans = [] } = {} } =
    useGetApplicationQuery();

  return {
    isLoadingApplication,
    offeringWholeLife: availablePlans.includes("whole_life"),
    missingZipCode: !zipCode,
  };
};

const PageContent = () => {
  const { isLoadingApplication, missingZipCode, offeringWholeLife } = useData();

  if (isLoadingApplication) {
    return (
      <CardSection>
        <BasicLoading />
      </CardSection>
    );
  }
  if (missingZipCode) {
    return (
      <CardSection>
        <MissingZipCode />
      </CardSection>
    );
  }
  if (!offeringWholeLife) {
    return (
      <CardSection>
        <NoCoverageOffered />
      </CardSection>
    );
  }
  return <WholeLifePage />;
};

const ChooseWholeLifeCoveragePage = ({ backLink, onClickBack }) => (
  <Page title="Choose Whole Life Coverage">
    <PageContent />
    <CardSection>
      <RoutedBackButton href={backLink} onClick={onClickBack} />
    </CardSection>
  </Page>
);

export default ChooseWholeLifeCoveragePage;
